/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Fri Jul 29 2022
*  File : ModuleLoader.ts
*******************************************/



import { ClientSdkCorePublic } from "@api-commons/sdk/ClientSdkPublicInterface.js";
import { PushServiceInterface } from "@api-commons/subscriptions/PushServiceInterface.js";
import { GuiController } from "@personal-area/gui/GuiController.js";

import { AbstractModuleLoader } from '@personal-area/modularization/AbstractModuleLoader.js';

import { GeopopGuiController } from "../gui/GeopopGuiController.js";
import { CatalogueLanguages } from "@ciaopeople/cp-shatsu/Catalogue";


export class GeopopModuleLoader extends AbstractModuleLoader {
    
    public getGui(): Promise<GeopopGuiController> {
        return super.getGui().then(
            g => g as GeopopGuiController
        );
    }

    protected initSdkClient(): Promise<ClientSdkCorePublic> {
        return import(/* webpackChunkName: "geopop/it/pa/sdk-client" */ "./modules/ClientLightweight.js").then(
            ({ SdkClient }) => {
                return SdkClient(this.configHelper.getOriginal(), this);
            }
             
        );
    }

    protected initSdkServer(): Promise<any> {
        return this.injectScript(this.configHelper.getSdkJsServerUrl(), "fp-sdk-server");
    }

    protected initPushHelper(): Promise<PushServiceInterface> {
        return this.getSdkClient().then(
            (sdk) => {
                return sdk.pushNotificationService;
            }
        );
    }


    protected initGui(): Promise<GuiController> {
        return this.getSdkClient().then(
           sdk => {
                const gui = import(/* webpackChunkName: "geopop/it/pa/gui" */ './modules/GUI.js');
                
                return gui.then(
                    ({ GUI }) => {
                        return GUI(
                            this.win,
                            sdk,
                            CatalogueLanguages.it
                        );
                    }
                );

            }
        );
    }


}